(() => {
  const root = document.querySelector('[data-tw-content="quantization-noise"]');
  if (!root || root.dataset.figureBound) return;
  root.dataset.figureBound = 'true';
  const dialog = root.querySelector('.tw-quantization-dialog');
  const image = dialog.querySelector('[data-zoom-image]');
  const caption = dialog.querySelector('#tw-quantization-caption');
  const sizeButton = dialog.querySelector('[data-zoom-size]');
  const scroll = dialog.querySelector('.zoom-scroll');
  let opener;
  root.querySelectorAll('.figure-zoom').forEach(button => {
    button.addEventListener('click', () => {
      opener = button;
      const source = button.querySelector('img');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      image.width = source.naturalWidth || Number(source.getAttribute('width'));
      image.height = source.naturalHeight || Number(source.getAttribute('height'));
      caption.textContent = button.closest('figure').querySelector('figcaption').textContent;
      scroll.dataset.original = 'false';
      sizeButton.textContent = '原寸で見る';
      sizeButton.setAttribute('aria-pressed', 'false');
      dialog.showModal();
      scroll.scrollTop = scroll.scrollLeft = 0;
    });
  });
  sizeButton.addEventListener('click', () => {
    const original = scroll.dataset.original !== 'true';
    scroll.dataset.original = String(original);
    sizeButton.setAttribute('aria-pressed', String(original));
    sizeButton.textContent = original ? '全体を表示' : '原寸で見る';
  });
  dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { if (opener) opener.focus(); });

  const footer = root.querySelector('.tw-quantization-share');
  const labels = { twitter: 'Xで共有', facebook: 'Facebookで共有', sharethis: 'その他の方法で共有' };
  const prepare = () => footer.querySelectorAll('.st-btn[data-network]').forEach(button => {
    const label = labels[button.dataset.network];
    if (!label) return;
    button.tabIndex = 0;
    button.setAttribute('role', 'button');
    button.setAttribute('aria-label', label);
  });
  new MutationObserver(prepare).observe(footer, { childList: true, subtree: true });
  prepare();
  footer.addEventListener('keydown', event => {
    const button = event.target.closest('.st-btn[data-network]');
    if (button && footer.contains(button) && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      button.click();
    }
  });
})();
